export default {
    validation: {
        'titleRequired': 'Please enter your title.',
        'firstnameRequired': 'Please enter your first name.',
        'firstNamePattern': 'Please enter a valid first name.',
        'lastNameRequired': 'Please enter your last name.',
        'lastNamePattern': 'Please enter a valid last name.',
        'nameMaxLength': 'This value is too long. It should have 100 characters or fewer.',
        'nameMinLength': 'Please enter at least 2 characters.',
        'emailAddressRequired': 'Please enter your email address.',
        'emailAddressError': 'Please enter a valid email address.',
        'confirmEmailAddressRequired': 'Please enter a valid email confirmation.',
        'confirmEmailAddressError': 'Email address and email confirmation must match.',
        'mobileNumberPattern': 'Mobile number should start with 08 followed by 8 digits.',
        'mobileNumberRequired': 'Please enter your mobile number.',
        'preContactRequired': 'Please select your preferred contact for order updates.',
        'dobRequired': 'Please enter your date of birth',
        'genderRequired': 'Please select your gender',
        'nationalityRequired': 'Please select your nationality',
        'residentialRequired': 'Please select your residential status',
        'addressProofRequired': 'Please select your proof of address',
        'addressTileRequired': 'Please select your time at address',
        'idRequired': 'Please select your ID type',
        'idNumberRequired': 'Please enter your ID number',
        'occupationStatusRequired': 'Please select your occupation status',
        'occupationTypeRequired': 'Please select your occupation type',
        'employerTimeRequired': 'Please select your time with employer',
        'serviceActiveChecked': 'Please select at least one option for "As an existing eir customer".',
        'serviceInactiveChecked': 'Please select at least one option for "No longer an eir customer".',
        'accHolderNameRequired': 'Please enter account holder name.',
        'accHolderNamePattern': 'Please enter a valid account holder name.',
        'accHolderNameMinLength': 'Please enter at least 2 characters.',
        'accHolderNameMaxLength': 'This value is too long. It should have 100 characters or fewer.',
        'bankIdentifierCodeRequired': 'Please enter your BIC.',
        'bankIdentifierCodeMinLength': 'Please enter at least 2 characters.',
        'bankIdentifierCodeMaxLength': 'This value is too long. It should have 100 characters or fewer.',
        'intBankAccNumberRequired': 'Please enter your IBAN.',
        'intBankAccNumberMinLength': 'Please enter at least 2 characters.',
        'intBankAccNumberMaxLength': 'This value is too long. It should have 100 characters or fewer.',
        'landLineRequired': 'Please select your landline option.',
        'movingBroadbandRequired': 'Please select your broadband provider option.',
        'broadbandProviderRequired': 'Please select current broadband provider.',
        'landlineNumberRequired': 'Please enter landline number.',
        'accountNumberRequired': 'Please enter account number.',
        'otherProviderRequired': 'Please enter other provider name.',
        'monitoredAlarmRequired': 'Please select monitored alarm option.',
        'masterSocketRequired': 'Please select option.',
        'techInstallRequired': 'Please select technician to install option.',
        'prefInstallationDateRequired': 'Please select preferred installation date.',
        'prefInstallationTimeRequired': 'Please select preferred installation time.',
        'bankAccNumberRequired': 'Please enter your bank account number',
        'bankAccNumberMinLength': 'Please enter at least 8 characters.',
        'bankAccNumberMaxLength': 'Please enter maximum of 8 characters.',
        'bankAccNumberPattern': 'This value should be a valid number.',
        'sortCodeRequired': 'Please enter your sort code',
        'sortCodeMinLength': 'Please enter at least 6 characters.',
        'sortCodeMaxLength': 'Please enter maximun of 6 characters.',
        'sortCodePattern': 'This value should be a valid number.',
        'timeAtBankRequired': 'Please select your time with current bank',
        'landLinePattern': 'Please enter numbers only',
        'landLinePatternMinLength': 'Please enter atleast 5 characters',
        'invalidAccount': 'Invalid account/phone number combination',
        'monitorAlarmAgreement': 'Please tick to indicate you are happy to move your home phone service online.',
        'custMobilePrefix': 'Please enter your eir mobile number prefix',
        'custMobileEirPhoneNo': 'Please enter a valid mobile number',
        'custMobileNetworkProvider': 'Please select your network provider',
        'custMobilePaymentType': 'Please select your payment type',
        'custMobileEirAccountNo': 'Please enter your existing account number',
        'registeredMobileNetwork': 'Please select option',
        'onlyAccountNumber': 'Please select option',
        'mobileDirectoryEnquiry': 'Please select option',
        'phoneNumberPattern': 'Please enter at least 7 characters.',
        'custEircodeRequired': 'Please enter Eircode',
        'keepMobileNumber': 'Please select option',

    },
};